import React, { Fragment } from 'react';
import PropTypes from  'prop-types';
import  { withStyles, createStyled } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import Filters from './Filters';


function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1, 
    //minHeight: 400,
   // padding: theme.spacing.unit * 1,
  },
  tabsRoot: {
     //borderBottom: '1px solid #e8e8e8',
   },
   tabsIndicator: {
     backgroundColor: '#00FEE6',
   },
   tabRoot: {
     border: '2px solid #C5C6C7',
     textTransform: 'initial',
     fontWeight: 'bold',
     marginRight: theme.spacing.unit * 4,
     fontFamily: [
       '-apple-system',
       'BlinkMacSystemFont',
       '"Segoe UI"',
       'Roboto',
       '"Helvetica Neue"',
       'Arial',
       'sans-serif',
       '"Apple Color Emoji"',
       '"Segoe UI Emoji"',
       '"Segoe UI Symbol"',
     ].join(','),
     '&:hover': {
     //  color: '#0B0C10',
       opacity: 1,
     },
     '&$tabSelected': {
     },
     '&:focus': {
     //  color: '#0B0C10',
     },
   },
   tabSelectedLight: {
    color: '#C5C6C7',
    fontWeight: 'bold',
   // backgroundColor:'#00FEE6',
    border: '2px solid #00FEE6',
  },
  tabSelectedDark: {
    color: '#C5C6C7',
    fontWeight: 'bold',
    //backgroundColor:'#1F2833',
    border: '2px solid #1F2833',
  }
});

@inject("commonStore")
@observer
class Contacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        value: 0,
    }
  }

  makeLabel = (value) => {
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
}
  makeTabs = (value) => {
    const { commonStore, classes, contactTypes, qualifier } = this.props;
    const { network } = commonStore
    const { types } = network
    const { contactTypes: networkContactTypes } = types

    const sortedContactTypes = networkContactTypes.filter(v => contactTypes.includes(v));
   
    return sortedContactTypes.map(contact => {
        return (<Tab
        key={contact}
        disableRipple
        style={{root: styles}}
        classes={{ root: classes.tabRoot, selected: qualifier === 'standard' ? classes.tabSelectedLight : classes.tabSelectedDark  }}
        label={this.makeLabel(contact)}
      />)
    })
  }
  makeTabBody = (value) => {
    const { classes, commonStore, contactTypes, ...otherProps } = this.props;
    if(value < contactTypes.length){
      const contact = contactTypes[value]

      return (
        <Fragment>
            <Filters contact={contact} {...otherProps} />
        </Fragment>
      )
    }
    return null
  }

  handleTabChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { value } = this.state
    const { classes } = this.props
    return (
      <div className={classes.root}>

            <Tabs
              value={value}
              onChange={this.handleTabChange}
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
              >
                   {this.makeTabs()}
            </Tabs>
            {this.makeTabBody(value)}
        </div>
    );
  }
}

Contacts.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contacts);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/Contacts.js